import React from 'react';
import CloseIcon from 'Assets/Icons/close.svg';
import { useRestrictModalNavigation } from './hooks/useRestrictModalNavigation';
import * as Styles from './styles';

interface IMobileDrawerProps {
    show: boolean;
    title?: string;
    hideClose?: boolean;
    className?: string;
    onClose?: () => void;
    children: React.ReactElement | React.ReactElement[];
}

const MobileDrawer: React.FC<IMobileDrawerProps> = ({
    show,
    title,
    hideClose,
    children,
    className,
    onClose,
}) => {
    //const { handleClose } = useRestrictModalNavigation(show, onClose);

    return (
        <Styles.Drawer
            className={className}
            anchor="bottom"
            open={show}
            onClose={onClose}
        >
            {!hideClose && (
                <Styles.IconWrapper onClick={onClose} id="close-button">
                    <CloseIcon />
                </Styles.IconWrapper>
            )}
            {title && <Styles.Heading variant="h5">{title}</Styles.Heading>}
            {children}
        </Styles.Drawer>
    );
};

export default MobileDrawer;
